module.exports = __webpack_public_path__ + "r-v3/img/ml_42_01.488be3d8.jpg";